import React from 'react';

export function Loader() {
    return <div className={'loaderContainer'}>
        <div className={'loader'}/>
    </div>;
}
